import {Article} from "./article";
import {PricingItem} from "./pricing-item";

export class DevicePricingItem extends PricingItem {
    public  device?: Article;
    public  collectorExtraPrice?: string;

}
